<template>
  <div id="why-popular">
    <div class="why-medical">
      <img :src="this.$t('lang.imgUrl.bmcBanner')" alt="" />
    </div>
    <div class="about-medical">
      <h3 class="about-title">
        {{ this.$t("lang.BetterMedicalCare.aboutBMC") }}
      </h3>
      <p class="about-content">
        {{ this.$t("lang.BetterMedicalCare.BMCDetail") }}
      </p>
      <p class="about-content">
        {{ this.$t("lang.BetterMedicalCare.ThereAreThree") }}
      </p>
    </div>
    <div class="three-round">
      <div :class="language">
        {{ this.$t("lang.BetterMedicalCare.moreEfficient") }}
      </div>
      <div :class="language">
        {{ this.$t("lang.BetterMedicalCare.moreExclusiveServices") }}
      </div>
      <div style="margin-right: 0" :class="language">
        {{ this.$t("lang.BetterMedicalCare.moreAffordable") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhyPopular",
  data() {
    return {
      language: "",
    };
  },
  mounted() {
    this.setStyle();
  },
  beforeUpdate() {
    this.setStyle();
  },
  methods: {
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.language = "round-item-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.language = "round-item";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#why-popular {
  width: 100%;
  /*height: 1280px;*/
  margin: 0 auto;
  overflow: hidden;
  .why-medical {
    height: 574px;
    width: 100%;
    /*background: url("../../assets/images/banner.png");*/
    /*background-size: 100% 100%;*/
    overflow: hidden;
    img {
      width: 100%;
    }
    p {
      text-align: center;
      font-size: 38px;
      color: #1186e9;
      width: 100%;
      height: 90px;
      line-height: 90px;
      margin-top: 405px;
      background: rgba(255, 255, 255, 0.5);
      font-weight: bold;
    }
  }
  .about-medical {
    width: 75%;
    margin: 0 auto;
    text-align: center;
    .about-title {
      margin: 36px 0;
      color: #444444;
      font-size: 26px;
    }
    .about-content {
      /*width: 75%;*/
      margin: 0 auto;
      text-align: left;
      line-height: 32px;
      text-indent: 2em;
      color: #515151;
    }
  }
  .three-round {
    width: $width;
    margin: 56px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .round-item {
      word-break: break-all;
      height: 48px;
      width: 128px;
      border: 16px solid rgba(210, 243, 244, 1);
      border-radius: 50%;
      padding: 70px 30px;
      color: #479aed;
      font-size: 20px;
      margin-right: 90px;
    }
    .round-item-us {
      word-break: break-all;
      height: 48px;
      width: 128px;
      border: 16px solid rgba(210, 243, 244, 1);
      border-radius: 50%;
      padding: 70px 30px;
      color: #479aed;
      font-size: 14px;
      margin-right: 90px;
    }
  }
}
</style>
